import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import VueCookie from 'vue-cookie';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';

Vue.prototype.$http = axios.create({
  baseURL: '/api/'
});
Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App)
}).$mount('#app');
